/**
 * Created by acastillo on 4/26/16.
 */

function apodization(spectraData, parameters){
    //org.cheminfo.hook.nemo.filters.ApodizationFilter

    /*public String toString() {
     switch (this) {
     case NONE:
     return "None";
     case EXPONENTIAL:
     return "Exponential";
     case GAUSSIAN:
     return "Gaussian";
     case TRAF:
     return "TRAF";
     case SINE_BELL:
     return "Sine Bell";
     case SINE_BELL_SQUARED:
     return "Sine Bell Squared";
     default:
     return "";
     }
     }*/
}

module.exports = apodization;


/*****************
 ** WEBPACK FOOTER
 ** ./src/filters/apodization.js
 ** module id = 48
 ** module chunks = 0
 **/